<app-pwa-install-banner />
<router-outlet />
